export const API_ERROR_REASON_REQUIRED_CONSENT =
  'Required consents are missing.';
